import React from "react";
import "../Button/Button.css";

/**
 * Square, icon-only button — shares Button's exact variant language and sizing
 * (so an IconButton sits flush next to a Button). Pass an accessible label.
 *
 * Props:
 *   variant: "primary" | "secondary" | "ghost" | "danger"  (default "ghost")
 *   size:    "sm" | "md" | "lg"                             (default "md")
 *   label:   accessible name (aria-label) — required for icon-only
 *   as:      element/component (default "button")
 */
const IconButton = ({
  variant = "ghost",
  size = "md",
  label,
  as: Tag = "button",
  className = "",
  disabled,
  children,
  ...rest
}) => (
  <Tag
    className={`gx-btn gx-iconbtn gx-btn--${variant} gx-btn--${size} ${className}`}
    aria-label={label}
    title={label}
    disabled={Tag === "button" ? disabled : undefined}
    aria-disabled={Tag !== "button" && disabled ? true : undefined}
    {...rest}
  >
    <span className="gx-btn-icon">{children}</span>
  </Tag>
);

export default IconButton;
